import { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom';
import './App.css';

import Home from './Home';
import About from './About';
import Books from './Books';
import MalamFamilyHistory from './MalamFamilyHistory';
import FamilyTree from './FamilyTree';
import EdwardMalam from './EdwardMalam';
import Contact from './Contact';

function ScrollToTop() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (hash) {
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [hash, pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/books" element={<Books />} />
        <Route path="/malamfamilyhistory" element={<MalamFamilyHistory />} />
        <Route path="/familytree" element={<FamilyTree />} />
        <Route path="/edwardmalam" element={<EdwardMalam />} />
        <Route path="/edwardmalam/:part" element={<EdwardMalam />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Router>
  );
}

export default App;
